import { render, staticRenderFns } from "./Vales_gasolina.vue?vue&type=template&id=708f976c&"
import script from "./Vales_gasolina.vue?vue&type=script&lang=js&"
export * from "./Vales_gasolina.vue?vue&type=script&lang=js&"
import style0 from "./Vales_gasolina.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports